var indentation_default = {
  "indentZero": "sDlj2",
  "indentOne": "K2IUf",
  "indentTwo": "_6WIdG",
  "indentThree": "n-Vug",
  "indentFour": "Zynxr",
  "indentFive": "XgEkc",
  "indentSix": "NQeor"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
